import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

interface IArg {
  language: string;
}

export const countryListApi: any = createApi({
  reducerPath: "countryListApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "../../../src/assets/countryLists",
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchCountryList: builder.query({
      query: (arg: IArg) => {
        return {
          url: `/${arg.language}.json`,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useFetchCountryListQuery } = countryListApi;
